import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import ExceptionIcon from 'components/exceptions/ExceptionIcon'
import { getExceptionTypeColor } from 'settings/constants/exceptionType'
import { ALPHA_38_PERCENT } from 'theme/colors'

// Card header avatar: a type-colored disc (registry) wrapping a dark inner disc with the
// white type glyph. Color resolves from exceptionType.ts so the card stays the single
// source of truth for per-type presentation.
type ExceptionTypeAvatarProps = {
  exceptionType?: string
}

const ExceptionTypeAvatar: React.FC<ExceptionTypeAvatarProps> = ({ exceptionType }) => {
  const theme = useTheme()
  const backgroundColor = getExceptionTypeColor(exceptionType)

  return (
    <Box
      sx={{ alignItems: 'center', backgroundColor, borderRadius: '8rem', display: 'flex', height: 40, justifyContent: 'center', width: 40 }}
    >
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: `${theme.palette.common.black}${ALPHA_38_PERCENT}`,
          borderRadius: '8rem',
          display: 'flex',
          height: 24,
          justifyContent: 'center',
          width: 24,
        }}
      >
        <ExceptionIcon exception={exceptionType} sx={{ color: theme.palette.common.white, fontSize: 20 }} />
      </Box>
    </Box>
  )
}

export default ExceptionTypeAvatar
